module.exports = __webpack_public_path__ + "static/media/sync.b57e4047.svg";